import { memorialApi } from "../misc/memorial.js";
import useSWR from "swr";
const fetchSummary = async (...args) => {
  const { data } = await memorialApi.getSummary();
  return data;
};

export const useSummary = () => {
  const { data, error, mutate } = useSWR("summary", fetchSummary, {
    refreshInterval: 5000,
  });
  return {
    summary: data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
};

const fetchTopN = async ({ n }) => {
  const { data } = await memorialApi.getTopN({ n });
  return data;
};

export const useTopN = (n) => {
  const { data, error, mutate } = useSWR("topN", () => fetchTopN({ n }));

  return {
    topN: data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
};

const fetchUserComment = async (keycloak) => {
  const token = keycloak.token;
  if (keycloak?.authenticated) {
    const { data } = await memorialApi.getuserComment(token);
    return data;
  }
};

export const useUserComment = (keycloak) => {
  const authenticated = keycloak?.authenticated;
  const { data, error, mutate } = useSWR(
    authenticated ? "userComment" : null,
    () => fetchUserComment(keycloak)
  );
  return {
    userComment: data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
};
